/**
 * MAISON — Shared storefront behavior
 * Intentionally small. Section-specific JS should stay with the section/component.
 */
(() => {
  const SELECTOR = '[data-maison-reveal]';
  let observer;

  function revealImmediately(root = document) {
    root.querySelectorAll(SELECTOR).forEach((element) => element.classList.add('is-visible'));
  }

  function initReveal(root = document) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealImmediately(root);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
      );
    }

    root.querySelectorAll(SELECTOR).forEach((element) => {
      if (!element.classList.contains('is-visible')) observer.observe(element);
    });
  }

  function boot(root = document) {
    document.documentElement.classList.add('maison-ready');
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  /* Re-initialize when Shopify Theme Editor reloads a section. */
  document.addEventListener('shopify:section:load', (event) => initReveal(event.target));

  window.MaisonTheme = {
    reveal: initReveal,
  };

  document.dispatchEvent(new CustomEvent('maison:ready'));
})();
